import axios from '../utils/axios'

// 获取物流反馈商品数据
export function LogisticsOrderInfoGet (params) {
  return axios({
    url: '/Sale/Task/LogisticsOrderInfoGet',
    method: 'get',
    params: params
  })
}

// 物流反馈提交
export function LogisticsAuditAdd (data) {
  return axios({
    url: '/Sale/Task/LogisticsAuditAdd',
    method: 'post',
    data: data
  })
}

export function SpreadFeedbackAdd (data) {
  return axios({
    url: '/Sale/Task/SpreadFeedbackAdd',
    method: 'post',
    data: data
  })
}
